/*
  cp-globo-form.js
  Runs the Globo forms that are rendered directly in the theme (snippets/cp-globo-form-*.liquid) instead of by the
  site-wide Globo app embed, which inlined ~466KB of form code into the head of every page.

  Behaviour mirrors Globo's own form script (Powerful Form Builder, bundle captured 2026-09-14) so the forms work
  exactly as before:
  - material labels: gfb__label__shink while focused, gfb__label__filled when a value is set
  - validation on change and on submit, with Globo's messages ("Email is required", "Email address is invalid")
  - searchable country dropdown (nice-select markup and classes, as Globo builds it)
  - submit: button gets .loading and is disabled; the same fields Globo sends are posted to
    https://app.powerfulform.com/api/front/form/<id>/send with the same X-Visitor-Id header
  - success (response success === "true"): form reset, the .message.success panel is shown (display:block). That
    element is what Google Tag Manager's "Lead Form Submit" trigger watches (element visibility on .success)
  - failure: the .message.error panel shows Globo's "Something went wrong, please try again"
  Deliberate difference from Globo: after a failed send the button is re-enabled so the visitor can try again
  (Globo left it disabled).
*/
(function () {
  'use strict';

  var MSG_REQUIRED = '{{ label | capitalize }} is required';
  var MSG_INVALID_EMAIL = 'Email address is invalid';
  var MSG_OTHER = 'Something went wrong, please try again';
  var EMAIL_RE = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  function capitalize(s) { return s ? s.charAt(0).toUpperCase() + s.slice(1).toLowerCase() : ''; }

  function visitorId() {
    try {
      var k = 'globo-visitor-id', v = localStorage.getItem(k);
      if (!v) {
        v = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) { var r = Math.random() * 16 | 0; return (c === 'x' ? r : (r & 3 | 8)).toString(16); });
        localStorage.setItem(k, v);
      }
      return v;
    } catch (e) { return ''; }
  }

  function cpAttr() {
    try {
      var m = document.cookie.match(/(?:^|;\s*)cp_attr=([^;]+)/);
      var v = m ? decodeURIComponent(m[1]) : '';
      return v && v !== '{}' ? v : '';
    } catch (e) { return ''; }
  }

  function fire(el, type) { var ev = document.createEvent('HTMLEvents'); ev.initEvent(type, true, false); el.dispatchEvent(ev); }

  /* ── Searchable dropdown (nice-select), same markup and classes Globo generates ─────────────────── */
  function NiceSelect(select) {
    this.el = select;
    this.placeholder = (select.querySelector('option[disabled]') || select.options[0] || { text: '' }).text;
    var cls = ['nice-select', select.getAttribute('class') || ''];
    var html = '<div class="' + cls.join(' ') + '" tabindex="0"><span class="current"></span><div class="nice-select-dropdown">' +
      '<div class="nice-select-search-box"><input type="text" class="nice-select-search" placeholder="Search..." title="search"/></div>' +
      '<ul class="list"></ul></div></div>';
    var old = select.nextElementSibling;
    if (old && old.classList.contains('nice-select')) old.remove();
    select.insertAdjacentHTML('afterend', html);
    this.dropdown = select.nextElementSibling;
    this.list = this.dropdown.querySelector('ul');
    this.items = [];
    var self = this;
    Array.prototype.forEach.call(select.options, function (o) {
      var li = document.createElement('li');
      li.textContent = o.text;
      li.setAttribute('data-value', o.value);
      li.className = 'option' + (o.selected ? ' selected' : ' null') + (o.disabled ? ' disabled' : '');
      li.addEventListener('click', function (e) { self.pick(li, o); });
      self.list.appendChild(li);
      self.items.push({ li: li, option: o });
    });
    this.render();
    this.dropdown.addEventListener('click', function (e) { e.preventDefault(); self.toggle(); });
    this.dropdown.addEventListener('keydown', function (e) { return self.key(e); });
    this.dropdown.addEventListener('focusin', function () { fire(select, 'focusin'); });
    this.dropdown.addEventListener('focusout', function () { fire(select, 'focusout'); });
    var search = this.dropdown.querySelector('.nice-select-search');
    search.addEventListener('click', function (e) { e.stopPropagation(); });
    search.addEventListener('input', function () { self.filter(search.value); });
    window.addEventListener('click', function (e) { if (!self.dropdown.contains(e.target)) self.dropdown.classList.remove('open'); });
  }
  NiceSelect.prototype.render = function () {
    var sel = this.el.options[this.el.selectedIndex];
    this.dropdown.querySelector('.current').textContent = sel && !sel.disabled && sel.value ? sel.text : this.placeholder;
  };
  NiceSelect.prototype.toggle = function () {
    var d = this.dropdown;
    if (d.classList.contains('open')) { d.classList.remove('open'); d.focus(); return; }
    d.classList.add('open');
    var s = d.querySelector('.nice-select-search'); s.value = ''; s.focus();
    this.items.forEach(function (it) { it.li.style.display = ''; it.li.classList.remove('focus'); });
    var cur = d.querySelector('.selected'); if (cur) cur.classList.add('focus');
  };
  NiceSelect.prototype.pick = function (li, option) {
    if (li.classList.contains('disabled')) return;
    this.items.forEach(function (it) { it.li.classList.remove('selected'); });
    li.classList.add('selected');
    this.el.value = option.value;
    this.render();
    fire(this.el, 'change');
  };
  NiceSelect.prototype.filter = function (q) {
    q = (q || '').toLowerCase();
    this.items.forEach(function (it) { it.li.style.display = !q || it.option.text.toLowerCase().indexOf(q) >= 0 ? '' : 'none'; it.li.classList.remove('focus'); });
    var next = this.next(null); if (next) next.classList.add('focus');
  };
  NiceSelect.prototype.next = function (from) {
    var e = from ? from.nextElementSibling : this.list.querySelector('.option');
    while (e) { if (!e.classList.contains('disabled') && e.style.display !== 'none') return e; e = e.nextElementSibling; }
    return null;
  };
  NiceSelect.prototype.prev = function (from) {
    var e = from ? from.previousElementSibling : this.list.querySelector('.option:last-child');
    while (e) { if (!e.classList.contains('disabled') && e.style.display !== 'none') return e; e = e.previousElementSibling; }
    return null;
  };
  NiceSelect.prototype.key = function (e) {
    var open = this.dropdown.classList.contains('open'), f = this.dropdown.querySelector('.focus'), t;
    if (e.keyCode === 13) { e.preventDefault(); if (open && f) f.click(); else this.toggle(); }
    else if (e.keyCode === 40 || e.keyCode === 38) {
      e.preventDefault();
      if (!open) { this.toggle(); return false; }
      t = e.keyCode === 40 ? this.next(f) : this.prev(f);
      if (t) { if (f) f.classList.remove('focus'); t.classList.add('focus'); t.scrollIntoView({ block: 'nearest' }); }
    } else if (e.keyCode === 27 && open) { this.dropdown.classList.remove('open'); this.dropdown.focus(); }
    return false;
  };
  NiceSelect.prototype.reset = function () {
    this.items.forEach(function (it) { it.li.classList.toggle('selected', it.option.selected); });
    this.render();
  };


  /* ── Visitor country (for selects marked data-cp-autocountry) ─────────────────────────────────────
     Shopify's /browsing_context_suggestions.json returns the country detected from the visitor's location. Globo's
     country list uses older names for some countries, so names are normalised and a few are aliased by ISO code.
     Only fills an empty field the visitor has not touched; if nothing matches it stays blank. */
  var COUNTRY_ALIASES = { CZ: 'Czech Republic', TR: 'Turkey', KR: 'South Korea', KP: "Korea, Democratic People's Republic Of", RU: 'Russia', VN: 'Vietnam', LA: "Lao People's Democratic Republic", IR: 'Iran, Islamic Republic Of', MD: 'Moldova, Republic of', TZ: 'Tanzania, United Republic Of', CD: 'Congo, The Democratic Republic Of The', CG: 'Congo', PS: 'Palestinian Territory, Occupied', SY: 'Syria', BO: 'Bolivia', VE: 'Venezuela', BN: 'Brunei', CV: 'Cape Verde', CI: "Côte d'Ivoire", MK: 'North Macedonia', SZ: 'Eswatini', RE: 'Reunion', HK: 'Hong Kong', MO: 'Macao', MM: 'Myanmar', TW: 'Taiwan', US: 'United States', GB: 'United Kingdom', AE: 'United Arab Emirates', CM: 'Republic of Cameroon', LY: 'Libyan Arab Jamahiriya', VA: 'Holy See (Vatican City State)', VC: 'St. Vincent', VG: 'Virgin Islands, British', PN: 'Pitcairn', GS: 'South Georgia And The South Sandwich Islands', UM: 'United States Minor Outlying Islands', TA: 'Saint Helena', AC: 'Saint Helena' };
  var countryPromise = null;
  function detectCountry() {
    if (!countryPromise) {
      countryPromise = fetch('/browsing_context_suggestions.json?country%5Benabled%5D=true', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) { var c = d && d.detected_values && d.detected_values.country; return c && c.handle ? { code: c.handle, name: c.name } : null; })
        .catch(function () { return null; });
    }
    return countryPromise;
  }
  function norm(s) {
    return (s || '').toLowerCase().replace(/\(.*?\)/g, ' ').replace(/&/g, ' and ').replace(/\bst\.?\s/g, 'saint ').replace(/\bsar\b/g, ' ')
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9 ]/g, ' ').replace(/\s+/g, ' ').trim();
  }
  function applyVisitorCountry(select, nice) {
    if (!select.hasAttribute('data-cp-autocountry')) return;
    detectCountry().then(function (c) {
      if (!c || select.value || select._cpTouched) return;
      var options = Array.prototype.filter.call(select.options, function (o) { return o.value; });
      var wanted = [COUNTRY_ALIASES[c.code], c.name].filter(Boolean).map(norm);
      var match = null;
      wanted.some(function (w) { return options.some(function (o) { if (norm(o.value) === w) { match = o; return true; } return false; }); });
      if (!match) { var n = norm(c.name); match = options.filter(function (o) { var v = norm(o.value); return n.length > 3 && (v.indexOf(n + ' ') === 0 || v.indexOf(n + ',') === 0); })[0] || null; }
      if (!match) return;
      select.value = match.value;
      if (nice) { nice.items.forEach(function (it) { it.li.classList.toggle('selected', it.option === match); }); nice.render(); }
      var label = select.closest('.globo-form-control') && select.closest('.globo-form-control').querySelector('.globo-label');
      if (label) label.classList.add('gfb__label__filled');
    });
  }

  /* ── Validation, as Globo renders it ──────────────────────────────────────────────────────────── */
  function fieldOf(control) { return control.querySelector('.globo-form-input input, .globo-form-input textarea, .globo-form-input select'); }
  function isShown(control) { return control.style.display !== 'none' && control.getAttribute('data-type') !== 'hidden'; }

  function validateControl(control) {
    var field = fieldOf(control);
    if (!field || !isShown(control)) return true;
    var label = (control.querySelector('.globo-label') || {}).getAttribute ? control.querySelector('.globo-label').getAttribute('data-label') : field.name;
    var value = (field.value || '').trim();
    var msg = '';
    if (field.hasAttribute('presence') && !value) msg = MSG_REQUIRED.replace('{{ label | capitalize }}', capitalize(label));
    else if (value && field.getAttribute('data-type') === 'email' && !EMAIL_RE.test(value)) msg = MSG_INVALID_EMAIL;
    control.classList.remove('has-error', 'has-success');
    control.querySelectorAll('.help-block.error').forEach(function (e) { e.parentNode.removeChild(e); });
    if (msg) {
      control.classList.add('has-error');
      field.setAttribute('aria-invalid', 'true');
      var holder = control.querySelector('.messages');
      if (holder) { var p = document.createElement('p'); p.className = 'help-block error'; p.innerHTML = msg; holder.appendChild(p); }
      return false;
    }
    control.classList.add('has-success');
    field.removeAttribute('aria-invalid');
    return true;
  }

  function validateForm(form) {
    var ok = true;
    form.querySelectorAll('.globo-form-control').forEach(function (c) { if (!validateControl(c)) ok = false; });
    form.querySelectorAll('.block-container').forEach(function (b) { b.classList.toggle('errors', !ok); });
    return ok;
  }

  function hideMessages(form) { form.querySelectorAll('.message').forEach(function (m) { m.style.display = 'none'; }); }
  function showMessage(el) {
    if (!el) return;
    var c = el.querySelector('.content');
    if (c && c.innerHTML !== '') { el.style.display = 'block'; el.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
  }

  /* ── Wire up one form ─────────────────────────────────────────────────────────────────────────── */
  function init(form) {
    if (form._cpGlobo) return;
    form._cpGlobo = true;
    var selects = [];

    form.querySelectorAll('.globo-form-control[data-type="country"] select[data-searchable="true"]').forEach(function (s, i, all) {
      var nice = new NiceSelect(s);
      selects.push(nice);
      s.closest('.globo-form-control').style.zIndex = '' + (all.length + all.length - i);
      s.addEventListener('change', function () { s._cpTouched = true; });
      applyVisitorCountry(s, nice);
    });

    form.querySelectorAll('.globo-form-control').forEach(function (control) {
      var label = control.querySelector('.globo-label');
      control.querySelectorAll('.globo-form-input input, .globo-form-input textarea, .globo-form-input select').forEach(function (el) {
        if (label) {
          el.addEventListener('focus', function () { label.classList.add('gfb__label__shink'); });
          el.addEventListener('focusout', function () { label.classList.remove('gfb__label__shink'); });
        }
        el.addEventListener('change', function () {
          if (label) {
            if (this.value) { label.classList.add('gfb__label__filled'); try { if (this.matches(':autofill')) label.classList.add('gfb__label__autofill'); } catch (e) {} }
            else { label.classList.remove('gfb__label__filled', 'gfb__label__autofill'); }
          }
          validateControl(control);
          var ok = !form.querySelector('.globo-form-control.has-error');
          form.querySelectorAll('.block-container').forEach(function (b) { b.classList.toggle('errors', !ok); });
        });
        if (el.getAttribute('data-type') === 'phone') {
          el.addEventListener('input', function () { el.value = el.value.replace(/[^0-9+\-\s]/g, ''); });
        }
      });
    });

    form.addEventListener('click', function (e) {
      var d = e.target.closest('[data-cp-dismiss]');
      if (d) { d.parentNode.style.display = 'none'; return; }
      var add = e.target.closest('[data-cp-repeater-add]');
      if (add) {
        var wrap = add.closest('.globo-form-control').querySelector('.gfb__form-inputs');
        var tmp = document.createElement('div'); tmp.innerHTML = wrap.innerHTML;
        tmp.firstElementChild.classList.add('gfb__no-label');
        tmp.firstElementChild.querySelectorAll('input').forEach(function (i) { i.value = ''; });
        wrap.appendChild(tmp.firstElementChild);
        return;
      }
      var rem = e.target.closest('[data-cp-repeater-remove]');
      if (rem) { var row = rem.closest('.globo-form-input'); if (row && row.parentNode.querySelectorAll('.globo-form-input').length > 1) row.remove(); }
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!validateForm(form)) {
        var first = form.querySelector('.globo-form-control.has-error');
        if (first) {
          // Globo moves the cursor to the first invalid field (its label then shrinks to the top), then scrolls to it
          var ff = fieldOf(first);
          if (ff && ff.type !== 'hidden') { try { ff.focus({ preventScroll: true }); } catch (err) { ff.focus(); } }
          first.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return;
      }
      var btn = form.querySelector("button[type='submit'],.action.submit");
      btn.classList.add('loading');
      btn.disabled = true;

      var set = function (name, value) { var f = form.querySelector('[name="' + name + '"]'); if (f) f.value = value; };
      set('page[title]', document.title);
      set('page[href]', window.location.href);
      var attr = cpAttr();
      var attrField = form.querySelector('[name="hidden-1"]');
      if (attr && attrField && (!attrField.value || attrField.value === '{}')) attrField.value = attr;

      // Product enquiry forms only (they carry data-cp-keylabel); every other form keeps its original behaviour.
      // _keyLabel is the field-name -> label map Globo's own script sends. Without it Globo's notification email to
      // info@ lists no details (the webhook still has them). (jb 2026-09-17)
      var cpProduct = form.hasAttribute('data-cp-keylabel');
      if (cpProduct) {
        var kl = form.querySelector('[name="_keyLabel"]');
        if (!kl) { kl = document.createElement('input'); kl.type = 'hidden'; kl.name = '_keyLabel'; form.appendChild(kl); }
        kl.value = form.getAttribute('data-cp-keylabel');
      }

      var body = new FormData();
      if (window.Shopify && Shopify.locale) body.append('locale', Shopify.locale);
      try { body.append('time_zone', Intl.DateTimeFormat().resolvedOptions().timeZone); } catch (err) {}
      new FormData(form).forEach(function (value, name) { if (name.indexOf('Confirm') === -1) body.append(name, value); });

      var headers = cpProduct ? { 'X-App-Version': '12x' } : {}; var vid = visitorId(); if (vid) headers['X-Visitor-Id'] = vid;
      fetch(form.getAttribute('action'), { method: 'POST', body: body, headers: headers })
        .then(function (r) { if (!r.ok) throw new Error(r.statusText || 'HTTP ' + r.status); return r.json(); })
        .then(function (res) {
          btn.classList.remove('loading');
          btn.removeAttribute('disabled');
          hideMessages(form);
          if (String(res && res.success) === 'true') {
            var submitted = {}; new FormData(form).forEach(function (v, k) { submitted[k] = v; });
            var clearForm = function () {
              form.reset();
              form.querySelectorAll('.gfb__label__shink,.gfb__label__filled,.gfb__label__autofill').forEach(function (l) { l.classList.remove('gfb__label__shink', 'gfb__label__filled', 'gfb__label__autofill'); });
              form.querySelectorAll('.globo-form-control').forEach(function (c) { c.classList.remove('has-success', 'has-error'); });
              selects.forEach(function (s) { s.reset(); s.el._cpTouched = false; applyVisitorCountry(s.el, s); });
            };
            // Product forms clear a few seconds AFTER the thank-you shows, so Google Tag Manager can still read the email
            // and phone for enhanced conversions. Other forms clear first, as before.
            if (!cpProduct) clearForm();
            showMessage(form.querySelector('[data-message-success],.message.success'));
            if (cpProduct) setTimeout(clearForm, 5000);
            document.dispatchEvent(new CustomEvent('globo.formbuilder.form.submitted', { detail: { form: form, formId: form.getAttribute('data-id'), response: res, values: submitted } }));
          } else {
            var errEl = form.querySelector('.message.error');
            var errs = res && res.errors && typeof res.errors === 'object' ? Object.keys(res.errors).map(function (k) { var c = form.querySelector('[data-element-id="' + k + '"] .globo-label'), lb = (c && c.getAttribute('data-label')) || k; return [].concat(res.errors[k]).join(' ').replace(/\{\{\s*label[^}]*\}\}/g, capitalize(lb)); }) : [];
            if (errEl) {
              errEl.querySelector('.content').innerHTML = '<div class="err-item"><span class="label"></span><span class="err">' + (errs.length ? errs.join('<br>') : (errEl.getAttribute('data-other-error') || MSG_OTHER)) + '</span></div>';
              showMessage(errEl);
            }
          }
        })
        .catch(function () {
          btn.classList.remove('loading');
          btn.removeAttribute('disabled');
          var errEl = form.querySelector('.message.error');
          if (errEl) {
            errEl.querySelector('.content').innerHTML = '<div class="err-item"><span class="label"></span><span class="err">' + (errEl.getAttribute('data-other-error') || MSG_OTHER) + '</span></div>';
            showMessage(errEl);
          }
        });
    });
  }

  function initAll() { document.querySelectorAll('form[data-cp-globo-form]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
